module.exports = __webpack_public_path__ + "img/img_road_2.79f12c0b.png";